let authentication = {
    init(){
        this.bootstrapInputValidation()
    },
    bootstrapInputValidation(){
      const forms = document.querySelectorAll('.needs-validation')
      Array.from(forms).forEach(form => {
        form.addEventListener('submit', event => {
          if (!form.checkValidity()) {
            event.preventDefault()
            event.stopPropagation()
          }
    
          form.classList.add('was-validated')
        }, false)
      })
    }
}


// authentication.init();